export const socialLinks = [
  {
    label: "Email",
    value: "nmaru2904@gmail.com",
    href: "mailto:nmaru2904@gmail.com",
    icon: "Mail",
  },
  {
    label: "Phone",
    value: "+91 89031 48273",
    href: "tel:+918903148273",
    icon: "Phone",
  },
  {
    label: "LinkedIn",
    value: "linkedin.com/in/arumugam-nallasivan",
    href: "https://linkedin.com/in/arumugam-nallasivan",
    icon: "Linkedin",
  },
  {
    label: "GitHub",
    value: "github.com/blackwolf2902",
    href: "https://github.com/blackwolf2902",
    icon: "Github",
  },
];